import { render, staticRenderFns } from "./Pending-Topups.vue?vue&type=template&id=234053d5&scoped=true"
import script from "./Pending-Topups.vue?vue&type=script&lang=js"
export * from "./Pending-Topups.vue?vue&type=script&lang=js"
import style0 from "./Pending-Topups.vue?vue&type=style&index=0&id=234053d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234053d5",
  null
  
)

export default component.exports